import emailJS from 'emailjs-com';
import { CooperationFormModel } from '@/components/introduction/model/cooperation-form.model';
import { MatchingFormModel } from '@/components/startup/model/matching-form.model';
import { SubscriptionFormModel } from '@/components/subscription/model/subscription-form.model';

const COOPERATION_FORM = 'Cooperation Form';
const MATCHING_FORM = 'Matching Form';

export const sendCooperationForm = async (
  emailServiceId: string,
  emailTemplateId: string,
  emailUserId: string,
  emailBody: CooperationFormModel,
) => {
  await emailJS.send(
    emailServiceId,
    emailTemplateId,
    {
      formType: COOPERATION_FORM,
      ...emailBody,
    },
    emailUserId,
  );
};

export const sendMatchingForm = async (
  emailServiceId: string,
  emailTemplateId: string,
  emailUserId: string,
  emailBody: MatchingFormModel,
) => {
  await emailJS.send(
    emailServiceId,
    emailTemplateId,
    {
      formType: MATCHING_FORM,
      ...emailBody,
    },
    emailUserId,
  );
};

export const sendSubscriptionForm = async (
  emailServiceId: string,
  emailTemplateId: string,
  emailUserId: string,
  emailBody: SubscriptionFormModel,
) => {
  await emailJS.send(
    emailServiceId,
    emailTemplateId,
    emailBody,
    emailUserId,
  );
};
